import { LoadScriptProps, useJsApiLoader } from '@react-google-maps/api';
import { getSystemPages } from '@store/app/app.slice';
import { useSelector } from 'react-redux';

const libraries: LoadScriptProps['libraries'] = ['places'];

export const useGoogleMaps = () => {
  const systemPages = useSelector(getSystemPages);
  const googleMapApiKey = systemPages.googleMapApiKey as string;

  return useJsApiLoader({
    region: 'no',
    language: 'no',
    googleMapsApiKey: googleMapApiKey,
    libraries,
  });
};
